// import { useRef, useState } from "react";
import ReactPlayer from 'react-player';
// import 'video.js/dist/video-js.css';
// import 'videojs-youtube';
// import ImageNotFound from '../../images/homepage/Image_not_available.png';
import { TikTok } from 'react-tiktok';
import './style.video.scss';
import { useRef, useEffect, useState } from 'react';

interface Props {
    item: any;
}
const VideoTiktok = (props: Props) => {

    // const [showVideo, setShowVideo] = useState<boolean>(false);
    // const playerRef = useRef<any>(null);

    // Hàm thực hiện thay thế ảnh khi ảnh bị lỗi
    // const handleImageError = (e: any) => {
    //     e.target.onerror = null;
    //     e.target.src = ImageNotFound;
    // }

    // const handleShowVideo = () => {
    //     setShowVideo(true);
    // }

    // const handleCancel = () => {
    //     setShowVideo(false);
    // }

    // Hàm thực hiện đóng popup
    // const closePopup = () => {
    //     if (playerRef.current) {
    //         playerRef.current.getInternalPlayer().stopVideo();
    //     }
    //     setShowVideo(false);
    // };

    const iframeRef = useRef<any>(null);
    const [code, setCode] = useState<string>('');

    useEffect(() => {
        if (iframeRef.current) {
            const iframeDocument = iframeRef.current.contentDocument;
            const blockAutoplay = iframeDocument.createElement('script');
            blockAutoplay.src = 'https://www.tiktok.com/embed.js';
            blockAutoplay.setAttribute('data-rmunx-org', '1');
            iframeDocument.head.appendChild(blockAutoplay);
        }
    }, []);

    useEffect(() => {
        const link = props.item.link;
        const parts = link.split('/');
        const id = parts[parts.length - 1];
        console.log(id); 
        setCode(id);   
    }, []);


    return (
        <>
            <iframe
                ref={iframeRef}
                src={`https://www.tiktok.com/embed/${code}?autoplay=0`}
                title="TikTok Video"
                allow="autoplay; encrypted-media;"
                allowFullScreen={true}
                className='video-items video-tiktok'
                style={{
                    overflow: 'hidden',
                    scrollbarWidth: 'none', // For Firefox
                    msOverflowStyle: 'none', // For Internet Explorer and Edge
                }}
            />

           
        </>
    )
}

export default VideoTiktok
